exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.disabled[data-v-361d77b9] {\n  background-color: #ffffff;\n}\n", ""]);

